import {GetHolderProfileCabinetResponsePayload, ProvidingListApplication} from '../../../shared/models/api';
import {AuthorizeEsiaResponsePayload} from '../../../shared/models/api/authorizeEsiaResponsePayload';
import {CardApplicationStatus} from '../../../types/enums/cardApplicationStatus';
import {CardStatus} from '../../../types/enums/cardStatus';
import {mapHolderProfileToEsiaRegInfo} from '../esiaRegCard/components/formMapper';
import {ActivationDecision, findLatestOwnApplicationWithDelivery, getCardActivationDecision} from './decision';

/** Local esiaRegInfo snapshot that still means pending activation (login restore / stale token). */
export const isStoredActivationSnapshotPending = (
  regInfo?: {
    cardDeliveryInfo?: unknown;
    cardApplicationStatusId?: number | null;
    cardStatusId?: number | null;
  } | null,
) =>
  Boolean(regInfo?.cardDeliveryInfo) &&
  (regInfo?.cardApplicationStatusId === CardApplicationStatus.AcceptFromClient ||
    regInfo?.cardApplicationStatusId === CardApplicationStatus.OnReview ||
    regInfo?.cardApplicationStatusId == null) &&
  regInfo?.cardStatusId != null &&
  regInfo.cardStatusId !== CardStatus.Active;

/**
 * Builds activation regInfo from Profile + Applications after a positive decision.
 * Status and delivery always come from the same application.
 */
export const buildCardActivationSnapshot = (
  holderProfile: GetHolderProfileCabinetResponsePayload,
  applications: ProvidingListApplication[] | null | undefined,
  decision: ActivationDecision = getCardActivationDecision({
    cardStatusId: holderProfile.cardStatusId,
    uscIsBlocked: holderProfile.uscIsBlocked,
    applications,
  }),
): AuthorizeEsiaResponsePayload | null => {
  if (!decision.shouldActivate) {
    return null;
  }

  const deliveryApplication = findLatestOwnApplicationWithDelivery(applications);

  return {
    ...mapHolderProfileToEsiaRegInfo(holderProfile),
    cardApplicationStatusId: deliveryApplication?.statusId,
    cardDeliveryInfo: deliveryApplication?.cardDeliveryInfo as AuthorizeEsiaResponsePayload['cardDeliveryInfo'],
  };
};
